import Header from '../components/header';
import AOS from 'aos';
// ..

export default {
  init() {
    // JavaScript to be fired on all pages
    Header.init();
    AOS.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js